var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.paycomplete)?_c('div',{staticClass:"pb-3",staticStyle:{"font-size":"18px"}},[_vm._v("\n    "+_vm._s(_vm.titleDetail)+"\n  ")]):_vm._e(),(_vm.paycomplete)?_c('div',{staticClass:"pb-3",staticStyle:{"font-size":"18px"}},[_vm._v("\n    "+_vm._s(_vm.text.titleDetail)+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }